var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"right-link mr-4",attrs:{"href":"javascript:window.location.reload()"}},[_c('i',{staticClass:"ti ti-reload"})])}]

export { render, staticRenderFns }